import { Injectable } from '@angular/core';
import { DealerOpeningHoursViewModel, DealerShiftRequestModel } from '../business-entities/dealer-opening-hours-view-model';

import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({ providedIn: 'root' })
export class DealerWorkingHoursDataService {
    constructor(
        private dataProvider: DataService
    ) {}

    getDealerWorkingHoursDetails(dealerId: string,occasionId:number): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealerWorkingHours, dealerId,occasionId).toPromise();
    }

    GetDealerLunchShiftDetails(dealerId: string):  Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealerLunchShiftDetails, dealerId).toPromise();
    }

    updateDealerWorkingHours(dealerWorkingHours: DealerShiftRequestModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<boolean>>(Urls.UpdateDealerWorkingHours, dealerWorkingHours).toPromise();
    }
    AddEditSpecialOccasion(occasionalShiftSaveViewModel:any){
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddEditSpecialOccasion, occasionalShiftSaveViewModel).toPromise();
    }
    GetSpecialOccasionList(dealerId:string){
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetSpecialOccasionList,dealerId).toPromise();
    }
    DeleteSpecialOccasion(occasionalShiftDeleteViewModel:any){
        return this.dataProvider.Post<GenericResponse<any>>(Urls.DeleteSpecialOccasion, occasionalShiftDeleteViewModel).toPromise();
    }

    //Dealer Customer Waiting Hours
    getDealerCustomerWaitingHoursDetails(dealerId: string): Promise<GenericResponse<any>>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealerCustomerWaitingHours, dealerId).toPromise();
    }

    addUpdateDealerCustomerWaitingHours(dealerCustomerWaitingHours: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<boolean>>(Urls.AddUpdateDealerCustomerWaitingHours, dealerCustomerWaitingHours).toPromise();
    }

    getDealerCustomerWaitingHoursDetailsById(dealerId: string, occasionId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetDealerCustomerWaitingHoursDetails, dealerId, occasionId).toPromise();
    }

    saveDealerCustomerWaitingHours(dealerCustomerWaitingHoursSaveModel: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<boolean>>(Urls.SaveDealerCustomerWaitingHours, dealerCustomerWaitingHoursSaveModel).toPromise();
    }

    deleteDealerCustomerWaitingHours(dealerCustomerWaitingHoursDeleteModel: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.DeleteDealerCustomerWaitingHours, dealerCustomerWaitingHoursDeleteModel).toPromise();
    }

    deleteDealerCustomerWaitingSlotHours(occasionId: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Delete<GenericResponse<any>>(Urls.DeleteDealerCustomerWaitingSlotHours, occasionId).toPromise();
    }
}